import "./Auth.scss";
import React, { useState } from "react";
import { authImg, logo, textImg } from "assets/images";
import { Button, Input } from "components/form";
import usePasswordToggle from "hooks/usePasswordToggle";
import useButtonLoader from "hooks/useButtonLoader";
import { userResetPasswordApi } from "services/auth";
import { removeErrorFields, validateInput } from "validation";
import { auth } from "validation/schema/auth";
import { toastMessage } from "utils/toastMessageHelper";
import useNavigation from "hooks/useNavigation";
import { useParams } from "react-router-dom";

const ResetPassword = () => {
  // Hook
  const { navigateTo } = useNavigation();
  const [inputType, icon] = usePasswordToggle();
  const [inputType2, icon2] = usePasswordToggle();
  const [resetButtonLoader, setResetButtonLoader] =
    useButtonLoader("Reset Password");
  const { token } = useParams();

  // Set all value
  const [inputData, setInputData] = useState({});
  const [error, setError] = useState({});

  // change handler
  const changeHandler = (event) => {
    const { name, value } = event.target;
    setInputData({ ...inputData, [name]: value });

    setError((prevError) => removeErrorFields(prevError, name));
  };

  // input validation
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "resetPasswordSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };

  // check mis-match password
  const checkMisMatchPassword = () => {
    if (inputData?.newPassword !== inputData?.confirmPassword) {
      toastMessage("Password mis-match", "warning", "userResetPassword");
      return false;
    }
    return true;
  };

  // Reset Password handler
  const userResetPasswordHandler = async (e) => {
    e.preventDefault();
    if (validation() && checkMisMatchPassword()) {
      try {
        setResetButtonLoader(true);
        const reqData = {
          ...inputData,
          token,
        };
        const { message = "", status } = await userResetPasswordApi(reqData);
        if (status === 200) {
          toastMessage(message, "success", "userResetPassword");
          setInputData({});
          setError({});
          navigateTo("/");
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setResetButtonLoader(false);
      }
    }
  };

  return (
    <>
      <div className="auth_page">
      <div className="image_section">
          <img src={logo} alt="" className="logo" />
          {/* <img src={authImg} alt="" className="side_img" /> */}
          <img src={textImg} alt="" className="text_img" />
        </div>
        <div className="auth_form">
          <form>
            <div className="form_title">
              <h3>Set New Password</h3>
              <p>Must be at least 8 characters.</p>
            </div>
            <div className="form_field password">
              <Input
                type={inputType}
                placeholder="Enter your password"
                label="New Password"
                name="newPassword"
                value={inputData?.newPassword}
                onChange={changeHandler}
                error={error?.newPassword}
                extraError={error?.newPasswordErr}
              />
              <span className="password_icons">{icon}</span>
            </div>
            <div className="form_field password">
              <Input
                type={inputType2}
                placeholder="Enter your password"
                label="Confirm Password"
                name="confirmPassword"
                value={inputData?.confirmPassword}
                onChange={changeHandler}
                error={error?.confirmPassword}
                extraError={error?.confirmPasswordErr}
              />
              <span className="password_icons">{icon2}</span>
            </div>

            <div className="button_wrap">
              <Button
                type={"button"}
                ref={resetButtonLoader}
                onClick={userResetPasswordHandler}
              >
                Reset Password
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
